import { render, staticRenderFns } from "./ManageLearnersReportDownloads.vue?vue&type=template&id=84580c78&"
import script from "./ManageLearnersReportDownloads.vue?vue&type=script&lang=js&"
export * from "./ManageLearnersReportDownloads.vue?vue&type=script&lang=js&"
import style0 from "./ManageLearnersReportDownloads.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports